module.exports = __webpack_public_path__ + "static/img/2-3.ffd881e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2-3.jpg
// module id = NoxJ
// module chunks = 0